import { firebaseMutations } from 'vuexfire'
import { initialState } from '../'

export default {
  setError (state, payload) {
    state.error = payload
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setUser (state, payload) {
    state.user = payload
  },
  updateUser (state, payload) {
    state.user = {
      ...state.user,
      ...payload
    }
  },
  setStripeCards (state, payload) {
    state.stripe.cards = {
      data: payload.data,
      hasMore: payload.has_more
    }
  },
  addStripeCards (state, payload) {
    state.stripe.cards = {
      data: [
        ...(state.stripe.cards.data || []),
        ...payload.data
      ],
      hasMore: payload.has_more
    }
  },
  setStripeInvoices (state, payload) {
    state.stripe.invoices = {
      data: payload.data,
      hasMore: payload.has_more
    }
  },
  appendStripeInvoices (state, payload) {
    state.stripe.invoices = {
      data: [
        ...(state.stripe.invoices.data || []),
        ...payload.data
      ],
      hasMore: payload.has_more
    }
  },
  prependStripeInvoices (state, payload) {
    const {hasMore, data} = state.stripe.invoices
    state.stripe.invoices = {
      data: [
        ...payload.data,
        ...(data || []),
      ],
      hasMore
    }
  },
  setStripeCustomer (state, payload) {
    state.stripe.customer = payload
  },
  setStripeSubscription (state, payload) {
    state.stripe.subscription = payload
  },
  setStripeCard (state, payload) {
    state.stripe.card = payload
  },
  setStripeCustomerLoading (state, payload) {
    state.stripe.status.customer.loading = payload
  },
  setStripeCardLoading (state, payload) {
    state.stripe.status.card.loading = payload
  },
  setStripeSubscriptionLoading (state, payload) {
    state.stripe.status.subscription.loading = payload
  },
  setStripeInvoicesLoading (state, payload) {
    state.stripe.status.invoices.loading = payload
  },
  reset (state) {
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  ...firebaseMutations
}
